// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"download_wrapper__32ErM","condition":"download_condition__1aJZl"};